/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Detail_UsernameInputs */

const en_audit_detail_username = /** @type {(inputs: Audit_Detail_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Username`)
};

const pt_br2_audit_detail_username = /** @type {(inputs: Audit_Detail_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuário`)
};

/**
* | output |
* | --- |
* | "Username" |
*
* @param {Audit_Detail_UsernameInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_detail_username = /** @type {((inputs?: Audit_Detail_UsernameInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Detail_UsernameInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_detail_username(inputs)
	return pt_br2_audit_detail_username(inputs)
});